import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { AxiosPublico } from "../../../componentes/axios/Axios";
import Card from '../../../componentes/contenedores/Card';
import GraficoBarra from '../../../componentes/graficos/Barras';
import FiltroFechaUI from "../../../componentes/metodos/FiltroFechaUI";
import useFechaFiltro from "../../../componentes/metodos/LogicaFiltro";
import Page from '../../../componentes/plantilla/Page';
import {
    InventariosExistencia,
    InventariosRotacion
} from '../../../configuracion/apiUrls';
moment.locale("es");

const InventariosAnalisis = () => {
    const [cargando, setCargando] = useState(true);
    const [chartExistencias, setChartExistencias] = useState(null);
    const [chartRotacion, setChartRotacion] = useState(null);

    const {
        filtro, setFiltro, fechaSeleccionada, setFechaSeleccionada,
        horaSeleccionada, setHoraSeleccionada, semanaSeleccionada, setSemanaSeleccionada,
        mesSeleccionado, setMesSeleccionado, anioSeleccionado, setAnioSeleccionado,
        obtenerFechasDeFiltro, maxAnio,
    } = useFechaFiltro();

    const cargarTodo = useCallback(async () => {
        setCargando(true);
        const fechas = obtenerFechasDeFiltro();
        const params = {
            fechaInicio: moment(fechas.fechaInicio).format('YYYY-MM-DD HH:mm:ss'),
            fechaFin: moment(fechas.fechaFin).format('YYYY-MM-DD HH:mm:ss'),
        };

        try {
            const [resExistencia, resRotacion] = await Promise.all([
                AxiosPublico.get(InventariosExistencia, { params }),
                AxiosPublico.get(InventariosRotacion, { params }),
            ]);

            // 1. Existencias en Inventario (Cantidad)
            if (resExistencia.data?.length > 0) {
                setChartExistencias({
                    labels: resExistencia.data.map(p => p.nombre || "N/A"),
                    data: resExistencia.data.map(p => parseFloat(p.existenciaTotal)),
                    colors: resExistencia.data.map(() => `rgba(153, 102, 255, 0.8)`),
                    titulo: "Stock Actual por Producto"
                });
            } else { setChartExistencias(null); }

            // 2. Rotación de Productos (Cantidad por día)
            if (resRotacion.data?.length > 0) {
                setChartRotacion({
                    labels: resRotacion.data.map(item => item.producto?.nombre || "N/A"),
                    data: resRotacion.data.map(item => parseFloat(item.cantidadVendida)),
                    colors: resRotacion.data.map(() => `rgba(255, 159, 64, 0.8)`),
                    titulo: "Rotación Diaria (Salida de Mercancía)"
                });
            } else {
                setChartRotacion(null);
            }

        } catch (error) {
            console.error("Error al cargar métricas:", error);
        } finally {
            setCargando(false);
        }
    }, [obtenerFechasDeFiltro]);

    useEffect(() => { cargarTodo(); }, []);

    const datos = {
        titulo: {
            titulo: "",
            url: "/app/admin/analisis/inventarios",
            tituloUrl: "Menu Principal",
            nombreUrl: "Inicio ",
        },
    };

    return (
        <Page datos={datos}>
            <Card>
                <FiltroFechaUI
                    filtro={filtro} setFiltro={setFiltro}
                    fechaSeleccionada={fechaSeleccionada} setFechaSeleccionada={setFechaSeleccionada}
                    horaSeleccionada={horaSeleccionada} setHoraSeleccionada={setHoraSeleccionada}
                    semanaSeleccionada={semanaSeleccionada} setSemanaSeleccionada={setSemanaSeleccionada}
                    mesSeleccionado={mesSeleccionado} setMesSeleccionado={setMesSeleccionado}
                    anioSeleccionado={anioSeleccionado} setAnioSeleccionado={setAnioSeleccionado}
                    handleApplyFilter={cargarTodo}
                    maxAnio={maxAnio}
                />
                <hr />
                {cargando ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status"></div>
                        <p className="mt-2">Calculando estadísticas...</p>
                    </div>
                ) : (
                    <div className="row g-4">
                        <div className="col-md-6">
                            {chartExistencias && <GraficoBarra datos={chartExistencias} esMonetario={false} />}
                        </div>
                        <div className="col-md-6">
                            {chartRotacion && <GraficoBarra datos={chartRotacion} esMonetario={false} />}
                        </div>
                    </div>
                )}
            </Card>
        </Page>
    );
}

export default InventariosAnalisis;